<template>
  <vs-wrapper v-if="locationHasCustomData" space="small">
    <div v-for="(field, key) in customFields">
      <template v-if="customData?.[key]">
        <vs-text type="caption">{{ field?.title }}:</vs-text>
        <vs-text type="caption">{{ formatValue(customData?.[key], field) }}</vs-text>
      </template>
    </div>
  </vs-wrapper>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { extractFieldsFromSchema } from '@/utils/field-schema-helper'
import { formatDateTime, formatDateWithYear } from '@/utils/date-formatting'

interface Props {
  customData: Record<any, any> | null
  rootSchema: Record<any, any> | null
}

const props = withDefaults(defineProps<Props>(), {
  customData: null,
  rootSchema: null,
})

const schema = computed(() => {
  return props.rootSchema?.schema
})

const uiSchema = computed(() => {
  return props.rootSchema?.uiSchema
})

const customFields = computed(() => {
  const customFields: Record<any, any> = {}
  extractFieldsFromSchema(schema.value, uiSchema.value, customFields)
  return customFields
})

const locationHasCustomData = computed(() => {
  return Object.keys(customFields.value).length > 0
})

const formatValue = (value: any, field: any) => {
  if (field.format) {
    switch (field.format) {
      case 'date':
        return formatDateWithYear(value)
      case 'date-time':
        return formatDateTime(value)
      default:
        return value
    }
  }
  return value
}
</script>
